import { Button, Form, Input, Layout } from "@vwfs-bronson/bronson-react";
import { FormikProvider, useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { SecondAuthRequest } from "../../../interfaces/auth.interface";
import * as Yup from "yup";
import { useAuth } from "../../../hooks/useAuth";
import Notifications from "../../ui/Notifications";
import { trackOnSecondAuthPageInputError } from "../../../adobeTracking/trackers";
import { useEffect } from "react";
import { FormField } from "../../common/FormField";

export const SecondAuthForm = () => {
    const { t } = useTranslation("secondauthfactor");
    const { authResponse, handleSecondAuthValidation, setLoading, handleResendTan } = useAuth();
    const formik = useFormik<SecondAuthRequest>({
        validationSchema: Yup.object().shape({
            tan: Yup.string().min(6, t("tan.error.min")).max(6, t("tan.error.max")).required(t("tan.error.required")),
        }),
        initialValues: { ...authResponse, tan: authResponse?.tan || undefined },
        enableReinitialize: true,
        onSubmit: (values) => {
            setLoading(true);
            handleSecondAuthValidation(values.tan ?? "");
        },
    });
    useEffect(() => {
        if (formik.errors && Object.keys(formik.errors).length > 0) trackOnSecondAuthPageInputError();
    }, [formik.errors, formik.isSubmitting]);
    return (
        <Layout.Item default="2/3" xl="3/4" xs="1/1">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit} noValidate={true}>
                    <FormField
                        hint={t("tan.example")}
                        name="tan"
                        labelText={t("tan.name")}
                        required
                        type="input"
                        className="u-mt-small"
                        render={(fieldProps: any) => <Input {...fieldProps} autoComplete={'one-time-code'} />}
                    />
                    <Notifications />
                    <div className="u-mt">
                        <Button full type="submit">
                            {t("continue_button")}
                        </Button>
                    </div>
                    <div className="u-mt u-text-center">
                        <p>
                            {t("resend_code.text1")}
                            <a onClick={handleResendTan}>
                                <u>{t("resend_code.clickabletext")}</u>
                            </a>
                            {t("resend_code.text2")}
                        </p>
                        <p>{t("resend_code.generictext")}</p>
                    </div>
                </Form>
            </FormikProvider>
        </Layout.Item>
    );
};

export default SecondAuthForm;
